export async function resolveClientTransactionVersions(authProvider) {
    if (!authProvider)
        return ['legacy', 0];
    if (typeof authProvider.supportedTransactionVersions === 'function') {
        try {
            const declared = await authProvider.supportedTransactionVersions();
            const versions = declared.filter((v) => v === 'legacy' || v === 0 || v === 1);
            // v1 needs a v1 signer no matter what the provider claims.
            return versions.filter((v) => v !== 1 || typeof authProvider.signTransactionV1 === 'function');
        }
        catch (_a) {
            return ['legacy', 0];
        }
    }
    return typeof authProvider.signTransactionV1 === 'function' ? ['legacy', 0, 1] : ['legacy', 0];
}
